let breadcrumb = {
    init() {
        breadcrumb.format();
        breadcrumb.responsive();
        breadcrumb.pro();
    },
    format(){
        let nbItem = $('.block-arrow-breadcrumbs nav ul li').length;
        if(nbItem == 1){
            $('<li>...</li>').appendTo('.block-arrow-breadcrumbs nav ul');
        }
        if(nbItem == 2){
            $('.block-arrow-breadcrumbs nav ul li:nth-child(2)').text('...')
        }
        if(nbItem == 3){
            $('.block-arrow-breadcrumbs nav ul li:nth-child(3)').text('...')
        }
        if(nbItem == 4){
            $('.block-arrow-breadcrumbs nav ul li:nth-child(4)').remove();
        }
    },
    responsive() {
        var ww = $(window).width();
        if(ww > 800){
            $('.header-page .col1 .block-arrow-breadcrumbs').remove();
        }else{
            $('.header-page .col1 .block-arrow-breadcrumbs').remove();
            $('.block-arrow-breadcrumbs').clone().prependTo('.header-page .col1');
        }

    },
    pro() {
        if(window.drupalSettings.ekko_pro.is_page_pro) {
            $('.block-arrow-breadcrumbs nav ul li:nth-of-type(1)').find('a').attr('href', window.drupalSettings.ekko_pro.url_pro_homepage);
        }
    }
}

export default breadcrumb;
